import React from "react";
import { useAuth } from "../contexts/AuthContext";
import SuperAdminDashboard from "../components/Dashboard/SuperAdminDashboard";
import { ROLES } from "../constants/roles";
import DoctorDashboard from "../components/Dashboard/DoctorDashboard";
import PublicDashboard from "../components/Dashboard/PublicDashboard";
import Loader from "../components/Common/Loader";

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Loader text="Loading dashboard..." />;
  }

  switch (user.role) {
    case ROLES.DOCTOR:
      return <DoctorDashboard />;
    case ROLES.SUPERADMIN:
      return <SuperAdminDashboard />;
    case ROLES.PUBLIC:
      return <PublicDashboard />;
    default:
      return (
        <div className="card p-6 text-center text-neutral-600">
          Unknown user role: {user.role || "None"}
        </div>
      );
  }
};

export default Dashboard;
